import { gql } from "apollo-boost";

const UPDATE_ADDRESS = gql`
  mutation UpdateAddress(
    $address: AddressInputV2
  ) {
    updateUserAddressSelfService(
      address: $address
    ) {
      status
      code
      message
      displayMessage
      address {
        normalized_street
        normalized_city
        normalized_subdivision
        normalized_postal_code
      }
    }
  }
`;

const REFETCH_ADDRESSES = gql`
  query RefetchAddresses {
    user {
      billing_address {
        street
        city
        state
        zip
        country
      }
      shipping_address {
        street
        city
        state
        zip
        country
      }
    }
  }
`;

export { REFETCH_ADDRESSES, UPDATE_ADDRESS };
